import { defineMessages } from 'react-intl';

export const addRatingCallToActionMessages = defineMessages({
  text: {
    id: 'customerRatings.addRatingCallToAction.text',
    defaultMessage: 'Verfasse eine Bewertung',
  },
});
